import Slide from '../components/Slide';
import { property } from '../data/pages';

export default function Property() {
  const { dataKey, heading, options } = property;
  return <Slide dataKey={dataKey} heading={heading} options={options} />;
}
